import React, { Component, createRef } from 'react';
import '../css/change-language-button.css';
import { ChevronDown } from 'lucide-react';
import { LanguageContext } from '../contexts/LanguageContext';
import 'flag-icons/css/flag-icons.min.css';

class ChangeLanguageButton extends Component {
    static contextType = LanguageContext;

    constructor(props) {
        super(props);
        this.state = {
            isDropdownOpen: false
        };
        this.wrapperRef = createRef();
    }

    languages = [
        { code: 'DE', name: 'Deutsch', flagClass: 'de' },
        { code: 'EN', name: 'English', flagClass: 'gb' },
        { code: 'FR', name: 'Français', flagClass: 'fr' },
        { code: 'ES', name: 'Español', flagClass: 'es' },
        { code: 'VN', name: 'Tiếng Việt', flagClass: 'vn' }
    ];

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        const savedLanguage = localStorage.getItem("lang");
        if (savedLanguage) {
            const langObj = this.languages.find(lang => lang.code === savedLanguage);
            if (langObj) {
                this.selectLanguage(langObj);
            }
        }
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
            this.setState({ isDropdownOpen: false });
        }
    };

    toggleDropdown = () => {
        this.setState(prevState => ({
            isDropdownOpen: !prevState.isDropdownOpen
        }));
    };

    selectLanguage = (language) => {
        this.context.setLanguage(language.code);
        this.setState({ isDropdownOpen: false });
        localStorage.setItem("lang", language.code)
    };

    render() {
        const { isDropdownOpen } = this.state;
        const { language } = this.context;
        const currentLang = this.languages.find(lang => lang.code === language);

        return (
            <div className="language-selector" ref={this.wrapperRef}>
                <button
                    className="language-button"
                    onClick={this.toggleDropdown}
                    aria-label="Change language"
                    title={currentLang.name}
                >
                    <span className={`fi fi-${currentLang.flagClass} flag`}></span>
                    <span className={`arrow ${isDropdownOpen ? 'arrow-up' : 'arrow-down'}`}>
                        <ChevronDown size={20} />
                    </span>
                </button>

                {isDropdownOpen && (
                    <div className="language-dropdown">
                        {this.languages.map(lang => (
                            <button
                                key={lang.code}
                                className={`language-option ${lang.code === language ? 'active' : ''}`}
                                onClick={() => this.selectLanguage(lang)}
                                title={lang.name}
                            >
                                <span className={`fi fi-${lang.flagClass} flag`}></span>
                                <span className="lang-code" style={{ fontSize: '1rem' }}>{lang.code}</span>
                            </button>
                        ))}
                    </div>
                )}
            </div>
        );
    }
}

export default ChangeLanguageButton;
